export default "__VITE_ASSET__BfbrjNL$__"